
import ogPagesMixins from '@/mixins/ogPagesMixins'

// Начальный лимит данных
const LIMIT = 10

// Url адрес для запроса данных
const URL = 'advertisements/products/discount'

// Настройки SEO полей head
const SEO = {
  TITLE: 'Акции со скидкой | Мегасреда',
  DESCRIPTION:
    'В этом разделе мы собрали софт, сервис и решения, обеспечивающие качественную работу специалистов и всей компании. Выбирайте то, что подойдёт именно вам. Все сервисы раздела можно получить со скидкой.',
  H1: 'Акции от компаний поставщиков продуктов и сервисов, предоставляемые со скидкой.',
  IMAGE: {
    url: 'https://megasreda.ru/img/products/offers_ogg.jpg',
    urlVk: 'https://megasreda.ru/img/products/offers_ogg-vk.jpg',
    urlTw: 'https://megasreda.ru/img/products/offers_ogg.jpg',
    type: 'image/jpeg',
    width: 1200,
    height: 630,
  },
}

export default {
  mixins: [ogPagesMixins],
  scrollToTop: true,

  async asyncData({ $axios }) {
    const { products, countAllPublishedProducts } = await $axios.$get(URL, {
      params: {
        grid: false,
        limit: LIMIT,
        offset: 0,
      },
    })
    return {
      products,
      productsCount: countAllPublishedProducts,
    }
  },

  data() {
    return {
      products: null,
      productsLimit: LIMIT,
      productsCount: 0,
      page: this.$route.query?.page ? this.$route.query.page : 1,
    }
  },
  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoH1() {
      return SEO.H1
    },
    seoImage() {
      return SEO.IMAGE
    },
    pageCount() {
      return Math.ceil(this.productsCount / this.productsLimit)
    },
    productsOffset() {
      return (this.page - 1) * this.productsLimit
    },
  },
  watch: {
    $route() {
      if (!this.$route.query?.page) {
        this.page = 1
        this.products = []
        this.$router.push({
          query: {},
        })
        this.fetchProducts()
      }
    },
  },

  methods: {
    paginateClick(page) {
      this.products = []
      if (page === 1) {
        this.$router.push({
          query: {},
        })
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: this.page,
          },
        })
        this.fetchProducts()
      }
      this.$scrollTo('body')
    },
    updateOffer() {
      this.products = []
      this.fetchProducts()
    },
    async fetchProducts() {
      const { products, countAllPublishedProducts } = await this.$axios.$get(
        URL,
        {
          params: {
            grid: false,
            limit: this.productsLimit,
            offset: this.productsOffset,
          },
        }
      )

      this.productsCount = countAllPublishedProducts
      if (this.products?.length) {
        this.products = this.products.concat(products)
      } else {
        this.products = products
      }
    },
    loadMore() {
      this.page++
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page,
        },
      })
      this.fetchProducts()
    },
  },
}
